import { render, staticRenderFns } from "./DiscussTab.vue?vue&type=template&id=4730f4a4&scoped=true&"
import script from "./DiscussTab.vue?vue&type=script&lang=js&"
export * from "./DiscussTab.vue?vue&type=script&lang=js&"
import style0 from "./DiscussTab.vue?vue&type=style&index=0&id=4730f4a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4730f4a4",
  null
  
)

export default component.exports